import script from "./BCUnitAbsence.vue?vue&type=script&lang=ts&setup=true"
export * from "./BCUnitAbsence.vue?vue&type=script&lang=ts&setup=true"

import "./BCUnitAbsence.vue?vue&type=style&index=0&id=5b9ba620&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b9ba620"]])

export default __exports__